export const CounterAnimation = new function() {

    this.init = () => {

    const counters = document.querySelectorAll('.count');
    counters.forEach(counter => {
        const counterValue = parseInt(counter.innerText);
        const duration = 4000;
        const easing = 'swing';
        let start = null;

        const animateCounter = timestamp => {
            if (!start) start = timestamp;
            const progress = timestamp - start;
            const increment = Math.ceil(counterValue * (progress / duration));

            counter.innerText = increment >= counterValue ? counterValue : increment;

            if (progress < duration) {
                window.requestAnimationFrame(animateCounter);
            } else {
                counter.innerText = counterValue;
            }
        };

        ScrollTrigger.create({
            trigger: counter,
            scroller: document.querySelector('#sn-page'),
            onEnter() {
                window.requestAnimationFrame(animateCounter);
            },
        })
    });
}
    
};